const handleVideoCall = (state = {}, action) => {
    switch (action.type) {
      case 'SET_VIDEO':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleVideoCall;